import React from 'react';

// Small monospace badge for the human-readable, immutable Task ID
// (e.g. TSK-000001). Renders nothing for legacy tasks still missing one.
export const TaskIdBadge = ({ taskId, className = '' }) => {
  if (!taskId) return null;
  return (
    <span
      className={`text-[13px] font-medium text-slate-900 ${className}`}
      data-testid={`task-id-badge-${taskId}`}
    >
      {taskId}
    </span>
  );
};

export default TaskIdBadge;
